import { AuthContext } from '@/context/AuthContext';
import ConductionAPI from '@/javascript/conduction-api';
import { Utils } from '@/javascript/utils';
import ConductionModal from '@/components/modals/ConductionModal';
import { Button, Group, Stack, Text, TextInput } from '@mantine/core';
import { IconAlertCircle, IconCheck, IconLock } from '@tabler/icons-react';
import { useContext, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

interface LiveEventSignUpProps {
	onClose: () => void;
}

const LiveEventSignUp: React.FC<LiveEventSignUpProps> = ({ onClose }) => {
	const auth = useContext(AuthContext);
	if (auth === undefined) {
		throw new Error("Modals must be a child of AuthContext.");
	}
	const token = auth.token;
	if (token === null) {
		return null;
	}

	const [searchParams] = useSearchParams();
	const defaultAccessCode = searchParams.get("accessCode") || null;
	const [accessCode, setAccessCode] = useState<string | null>(defaultAccessCode ?? null);

	const handleAccessCodeSubmit = () => {
		if (accessCode === null) return;

		ConductionAPI.signUpForLiveEvent(accessCode, token)
			.then((success: boolean) => {
				if (success) {
					Utils.displayNotification(
						"You're signed up!",
						"You have signed up for the live event",
						"green",
						<IconCheck size={16} />
					);
					onClose();
				} else {
					Utils.displayNotification(
						"Sign up failed.",
						"The access code provided is invalid or the sign-up limit has been reached.",
						"red",
						<IconAlertCircle size={16} />
					);
				}
			}
			);
	};

	return (
		<ConductionModal
			onClose={onClose}
			title="Live Event Sign Up"
			size="sm"
		>
			<Stack>
				<Text size="lg">
					Enter the live event code to sign up!
				</Text>
				<TextInput
					label={
						<Group>
							<IconLock size={20} />
							<Text>Access Code</Text>
						</Group>
					}
					onChange={(event) => setAccessCode(event.target.value)}
					onSubmit={handleAccessCodeSubmit}
				/>
				<Button
					onClick={handleAccessCodeSubmit}
					fullWidth
					disabled={accessCode === null || accessCode.length === 0}
				>
					Sign Up
				</Button>
			</Stack>
		</ConductionModal>
	);
};

export default LiveEventSignUp;
